export interface ICardStoryContent {
  titleKey: string;
  descriptionKey: string;
}

const LAST_STEP_WITH_STORY = 30;

export const APRIL_MADNESS_CARD_STORY_CONTENT = Object.fromEntries(
  Array.from({ length: LAST_STEP_WITH_STORY }, (_, index) => {
    const step = index + 1;

    return [
      step,
      {
        titleKey: `EVENT.EVENT_CARD_HUM.CARD_${step}.H_1`,
        descriptionKey: `EVENT.EVENT_CARD_HUM.CARD_${step}.D_1`,
      },
    ];
  }),
) as Record<number, ICardStoryContent>;
